export const STAGES = [
  { key: "new", label: "New" },
  { key: "contacted", label: "Contacted" },
  { key: "qualified", label: "Qualified" },
  { key: "site_visit", label: "Site Visit" },
  { key: "commercial_discussion", label: "Commercial Discussion" },
  { key: "negotiation", label: "Negotiation" },
  { key: "legal", label: "Legal" },
  { key: "loi", label: "LOI" },
  { key: "agreement", label: "Agreement" },
  { key: "handover", label: "Handover" },
];

export const STAGE_LABEL = Object.fromEntries(STAGES.map((s) => [s.key, s.label]));

export const STAGE_COLORS = {
  new: "bg-blue-100 text-blue-800 border-blue-200",
  contacted: "bg-indigo-100 text-indigo-800 border-indigo-200",
  qualified: "bg-amber-100 text-amber-800 border-amber-200",
  site_visit: "bg-emerald-100 text-emerald-800 border-emerald-200",
  commercial_discussion: "bg-rose-100 text-rose-800 border-rose-200",
  negotiation: "bg-orange-100 text-orange-800 border-orange-200",
  legal: "bg-purple-100 text-purple-800 border-purple-200",
  loi: "bg-cyan-100 text-cyan-800 border-cyan-200",
  agreement: "bg-teal-100 text-teal-800 border-teal-200",
  handover: "bg-green-100 text-green-800 border-green-200",
};

export const PROPERTY_STATUS = {
  active_deal: { label: "Active Deal", cls: "bg-blue-100 text-blue-800 border-blue-200" },
  rejected_archive: { label: "Rejected", cls: "bg-rose-100 text-rose-800 border-rose-200" },
  dormant: { label: "Dormant", cls: "bg-gray-100 text-gray-700 border-gray-200" },
  live_hostel: { label: "Live Hostel", cls: "bg-green-100 text-green-800 border-green-200" },
};

export const REJECTION_REASONS = [
  { key: "price_mismatch", label: "Price mismatch" },
  { key: "location_unsuitable", label: "Location unsuitable" },
  { key: "owner_not_interested", label: "Owner not interested" },
  { key: "property_unfit", label: "Property unfit" },
  { key: "competitor", label: "Lost to competitor" },
  { key: "unresponsive", label: "Unresponsive" },
  { key: "other", label: "Other" },
];

export const REVISABLE = [
  { key: "target_go_live", label: "Target Go-Live Date" },
  { key: "commercial_terms", label: "Commercial Terms" },
  { key: "target_bed_count", label: "Target Bed Count" },
];

export const SOURCE_LABEL = {
  manual: "Manual", whatsapp: "WhatsApp", csv: "CSV", gsheet: "Google Sheet",
  gmail: "Gmail", meta_ads: "Meta Ads", consultant: "Consultant",
};

export const PRIORITIES = [{ key: "low", label: "Low" }, { key: "medium", label: "Medium" }, { key: "high", label: "High" }];
export const PRIORITY_COLORS = {
  low: "bg-gray-100 text-gray-600 border-gray-200",
  medium: "bg-amber-100 text-amber-800 border-amber-200",
  high: "bg-rose-100 text-rose-800 border-rose-200",
};
export const LEAD_STATUSES = [
  { key: "new", label: "New" }, { key: "follow_up", label: "Follow Up" },
  { key: "duplicate", label: "Duplicate" }, { key: "promoted", label: "Promoted" },
];
export const LEAD_REJECTION_REASONS = [
  { key: "not_interested", label: "Not interested" }, { key: "bad_location", label: "Bad location" },
  { key: "too_small", label: "Too small" }, { key: "duplicate", label: "Duplicate" }, { key: "other", label: "Other" },
];
export const LEAD_REJECTION_LABEL = Object.fromEntries(LEAD_REJECTION_REASONS.map((r) => [r.key, r.label]));

export function fmtDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
}
export function fmtDay(iso) {
  if (!iso) return "";
  try { return new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }); }
  catch { return iso; }
}
